import { render, staticRenderFns } from "./deleteFolderDialog.vue?vue&type=template&id=5579ff42"
import script from "./deleteFolderDialog.vue?vue&type=script&lang=js"
export * from "./deleteFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports